import { DepartmentTypes } from "../../../PatientCare/PatientBooking/v1/types";

export type SearchParamsType = {
      isActive:number,
      searchText:string,
      deptId?:number,
};

export type MasterTableDataType = {
  description: string;
  deptId: number;
  deptName: string;
  subDeptName: string;
  clinicId: number;
  createdDate: string | null;
  isActive: number;
  updatedDate: string | null;
  subDeptId: number | null;
};

export type MasterDataType = {
  description: string;
  deptId: number;
  deptName: string;
  subDeptName: string;
  clinicId: number;
  isActive: number;
  subDeptId: number | null;
  createdDate: string | null;
  updatedDate: string | null;
  cptGroupId?:number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  description: string;
  department: DepartmentTypes | null;
  subDeptName: string;
  createdDate: string | null;
  isActive: number;
  updatedDate: string | null;
};

export const initialFormData: MasterFormDataType = {
  description: "",
  department: null,
  subDeptName: "",
  createdDate: null,
  isActive: 0,
  updatedDate: null,
};
